import { baseAPI } from "../../../baseApi";
import { tagsTypes } from "../../../tagsTypes";

export const productPolicySlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Save product policy information
    postProductPolicyInfo: builder.mutation({
      query: (data) => ({
        url: "product-policy-accept",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // get product policies
    getProductPolicies: builder.query({
      query: () => ({
        url: "product-policies",
        method: "GET",
      }),
    }),

    // Get product voucher expiry details (POST request)
    postProductVoucherExpiry: builder.mutation({
      query: (data) => ({
        url: "product-voucher-expiry",
        method: "POST",
        body: data, // Ensure to pass necessary data in the request body
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),
  }),
});

export const {
  usePostProductPolicyInfoMutation,
  useGetProductPoliciesQuery,
  usePostProductVoucherExpiryMutation,
} = productPolicySlice;
